import { Typography } from "antd"
import { formatDate, fromNow } from "../invoiceModel"

type Props = {
  date: string
}

const InvoiceDateDisplay = ({date}: Props) => {
  return <div>
    {formatDate(date)}
    <br/>
    <Typography.Text type="secondary"><small>({fromNow(date)})</small></Typography.Text>
  </div>
}

export default InvoiceDateDisplay
